'use strict';

import React, { useState } from 'react';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import { format } from 'date-fns';
import cn from 'classnames/bind';

import { appSelectors, appOperations } from '@/state/domains/app';
import { locationListSelectors, locationListOperations } from '@/state/domains/locationList';
import { ordersSelectors, ordersOperations } from '@/state/domains/orders';

import { getDerivedRoles } from '@/roles';

import s from './styles.scss';
import m from '../styles.scss';

export default connect(
	(state, props) => ({
		modals: appSelectors.getModalStates(state, props),
		modalProps: appSelectors.getModalProps(state, props),
	}),
	{
		setModalClose: appOperations.setModalClose,
		postAssignJobs: ordersOperations.postAssignJobs,
	}
)(
	({
		modals,
		modalProps,
		setModalClose,
		postAssignJobs,
	}) => {

		const [ route, setRoute ] = useState(true);
		const today = format(new Date(), 'yyyy-MM-dd');
		const [ date, setDate ] = useState(today);
		const [ overwrite, setOverwrite ] = useState(false);
		const { user, items } = modalProps;

		const assignUser = () => {

			const data = {
				route,
				date,
				username: user.username,
				items,
				append: !overwrite,
			};

			postAssignJobs(data).then(
				result => {
					if (result.success) {
						console.log(result);
					}
				}
			);

			setModalClose('assignUser');
		};

		const roles = getDerivedRoles(user);

		const checkbox = roles.reduce(
			(inc, r) => {
				if (!inc && [ 'server', 'messenger' ].includes(r)) {
					return true;
				}
				return inc;
			},
			false
		);

		const onDateChange = e => setDate(e.target.value);

		return (
			<Modal
				appElement={ document.getElementById('root') }
				overlayClassName={ m.modalOverlay }
				isOpen={ modals.assignUser }
				contentLabel='Confirm Assign'
				shouldCloseOnOverlayClick={ true }
				shouldCloseOnEsc={ true }
				onRequestClose={ () => setModalClose('assignUser') }
				className={ m.modal }
			>
				<div className={ s.root }>
					{ !!items.length &&
						<>
							<div className={ s.assignRow }>
								<div className={ s.assign }>Assign to</div>
								<div className={ s.userName }>
									{ `${ user.firstName } ${ user.lastName }` }
								</div>
							</div>
							<div className={ s.forms }>
								{ checkbox &&
									<div
										className={ s.checkboxCont }
										onClick={ () => setRoute(!route) }
									>
										<input
											type='checkbox'
											checked={ route }
											readOnly
										/>
										<label>
											Route jobs
										</label>
									</div>
								}
								{ route && 
									<div>
										<input
											type='date'
											className={ s.datePicker }
											onChange={ onDateChange }
											value={ date }
										/>
									</div>
								}
							</div>
							<div className={ m.btns }>
								<div
									className={ s.checkboxCont }
									onClick={ () => setOverwrite(!overwrite) }
								>
									<input
										type='checkbox'
										checked={ overwrite }
										readOnly
									/>
									<label>
										Overwrite
									</label>
								</div>
								<button
									onClick={ () => setModalClose('assignUser') }
									className={ m.cancel }
								>
									Cancel
								</button>
								<button
									onClick={ assignUser }
									className={ m.proceed }
								>
									Assign
								</button>
							</div>
						</>
					}
					{ !items.length &&
						<>
							<div className={ s.assignRow }>
								<div className={ s.assign }>No items selected</div>
							</div>
							<div className={ m.btns }>
								<button
									onClick={ () => setModalClose('assignUser') }
									className={ m.cancel }
								>
									Ok
								</button>
							</div>
						</>
					}
				</div>
			</Modal>
		);
	}
);
